import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'

export default class TPeriodDM extends Data {
	public static className = 'TPeriodDM'
	public static primaryKey = 'Id'
	public static systemFields = [
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	DateTo?: Date
	DateFrom?: Date
	RightGroupId?: number
	Description?: string
	Abbr?: string
	Id?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	RightGroupIdCalc?: number
}